import React, { useEffect, useRef, useState } from "react";
import { partiallyHideHash, pxToRem } from "@/util/common";
import { createUseStyles } from "react-jss";
import useCustomStyles from "@/hooks/useCustomStyles";
import { Button, Grid, Collapse } from "antd-mobile";
import useCenterPopup from "@/hooks/useCenterPopup";
import useCustomTranslation from "@/hooks/useTranslation";
import { DownFill } from "antd-mobile-icons";
import Remark from "@/pages/OtherMember/comp/Remark";

const OtherTinyChen: React.FC<{
	data: Record<string, any>[];
}> = ({ data }) => {
	const classes = useStyles();
	const useClasses = useCustomStyles();
	const { t } = useCustomTranslation();
	const RemarkPopup = useCenterPopup();
	const [memberActiveKey, setMemberActiveKey] = useState<string[]>([]);
	const [list, setList] = useState<any[]>([]);
	const dataRemark = useRef<any>({});

	useEffect(() => {
		setList(data);
	}, [data]);

	const userStatusHandle = (status: number) => {
		// 1/有效 0/无效
		let result = t("Invalid");
		if (status === 1) {
			result = t("Normal");
		}
		return result;
	};

	const renderOperationToolbar = (data: Record<string, any>) => {
		const buttonsData = [
			{
				name: t("Remark"),
				key: "remark",
			},
		];
		const menuLinkHandle = (key: string) => {
			switch (key) {
				case "remark":
					dataRemark.current = data;
					RemarkPopup.showPopup();
					break;
			}
		};
		return (
			<div className={classes.buttonsWrap}>
				<Grid columns={1} gap={[15, 8]}>
					{buttonsData.map((item, index) => {
						return (
							<Grid.Item key={index}>
								<Button
									onClick={() => menuLinkHandle(item.key)}
									block
									shape="rounded"
									fill="outline"
									style={{
										width: pxToRem(140),
										fontSize: pxToRem(14),
										fontWeight: "400",
										"--text-color": "#82E8FF",
										"--background-color": "transparent",
										"--border-color": "#4C66C7",
									}}
								>
									{item.name}
								</Button>
							</Grid.Item>
						);
					})}
				</Grid>
			</div>
		);
	};

	return (
		<div className={classes.listContainer}>
			<Collapse
				onChange={(keys) => {
					setMemberActiveKey(keys);
				}}
				arrow={<DownFill fontSize={pxToRem(12)} color="#B299FF" />}
			>
				{list.map((item, index) => {
					return (
						<Collapse.Panel
							className={
								memberActiveKey.indexOf(index + "") >= 0
									? "active"
									: ""
							}
							key={index + ""}
							title={
								<div className={classes.head}>
									<div className="l">
										<span>{item.recordNickname}</span>
									</div>
									<div className="r">
										<span>{t("Status")} </span>
										<span
											style={{
												color: "#8BFF78",
												paddingLeft: pxToRem(8),
											}}
										>
											{userStatusHandle(+item.status)}
										</span>
									</div>
								</div>
							}
						>
							<div className={`${classes.tinyChenWrap}`}>
								<Grid columns={2} gap={[0, 16]}>
									<Grid.Item>
										<dl className={useClasses.dlWrap}>
											<dt>{t("Address")}</dt>
											<dd>
												{partiallyHideHash(
													item.recordWalletAddress
												)}
											</dd>
										</dl>
									</Grid.Item>
									<Grid.Item>
										<dl className={useClasses.dlWrap}>
											<dt>{t("Remark")}</dt>
											<dd className="tinydd">
												{item.remark || "-"}
											</dd>
										</dl>
									</Grid.Item>
									<Grid.Item>
										<dl className={useClasses.dlWrap}>
											<dt>{t("SignTime")}</dt>
											<dd className="tinydd">
												{item.createTime || "-"}
											</dd>
										</dl>
									</Grid.Item>
									<Grid.Item>
										<dl className={useClasses.dlWrap}>
											<dt>{t("LastLoginTime")}</dt>
											<dd className="tinydd">
												{item.lastRecordTime || "-"}
											</dd>
										</dl>
									</Grid.Item>
								</Grid>
								{renderOperationToolbar(item)}
							</div>
						</Collapse.Panel>
					);
				})}
			</Collapse>
			<RemarkPopup.PopupComp
				visible={RemarkPopup.visiblePopup}
				onClose={RemarkPopup.closePopup}
				bodyStyle={{ background: "transparent" }}
				onMaskClick={() => {
					RemarkPopup.closePopup();
				}}
				className="centerPopupAfoot"
				style={{ "--max-width": "100vw" }}
			>
				<Remark
					onVisiblePopup={RemarkPopup.closePopup}
					data={dataRemark.current}
				/>
			</RemarkPopup.PopupComp>
		</div>
	);
};

export default OtherTinyChen;

const useStyles = createUseStyles({
	listContainer: {
		// backgroundColor: 'red',
		"& .adm-list": {
			padding: 0,
			border: "none",
		},
		"& .adm-list-body": {
			backgroundColor: "transparent",
			border: "none",
		},
		"& .adm-collapse-panel-content": {
			marginBottom: pxToRem(8),
		},
		"& .adm-list-item-content": {
			borderTop: "none",
			padding: 0,
		},
		"& .adm-list-item-content-main": {
			padding: 0,
		},
		"& .adm-list-item": {
			padding: 0,
			backgroundColor: "transparent",
		},
		"& .adm-collapse-panel-header": {
			borderRadius: pxToRem(20),
			overflow: "hidden",
			background: "linear-gradient(#181B24, #232C48)",
			border: "1px solid #3A375D",
			transition: "all 0.6s",
			paddingRight: pxToRem(14),
		},
		"& .active": {
			borderBottomLeftRadius: 0,
			borderBottomRightRadius: 0,
		},
	},
	head: {
		display: "flex",
		alignItems: "center",
		height: pxToRem(50),
		padding: {
			left: pxToRem(18),
			right: pxToRem(8),
		},
		"& .l": {
			flex: 1,
			overflow: "hidden",
			display: "flex",
			alignItems: "center",
			fontSize: pxToRem(18),
			fontWeight: "700",
			color: "#FFFFFF",
			"& >span": {
				paddingLeft: pxToRem(4),
				whiteSpace: "nowrap",
				textOverflow: "ellipsis",
				overflow: "hidden",
			},
		},
		"& .r": {
			overflow: "hidden",
			display: "flex",
			fontSize: pxToRem(13),
			fontWeight: "500",
			color: "#868FA8",
			"& span": {
				whiteSpace: "nowrap",
				textOverflow: "ellipsis",
				overflow: "hidden",
				textAlign: "right",
			},
		},
	},
	tinyChenWrap: {
		padding: {
			left: pxToRem(20),
			right: pxToRem(20),
			bottom: pxToRem(20),
		},
		border: "1px solid #3A375D",
		borderTop: "none",
		borderBottomLeftRadius: pxToRem(20),
		borderBottomRightRadius: pxToRem(20),
		overflow: "hidden",
		background: "linear-gradient(156deg, #181B24 5.2%, #232C48 97.46%)",
	},
	buttonsWrap: {
		display: "flex",
		justifyContent: "center",
		padding: {
			top: pxToRem(18),
		},
	},
	scheme: {
		position: "relative",
		"&::after": {
			content: '""',
			position: "absolute",
			top: "50%",
			right: pxToRem(22),
			transform: "translate(0, -50%)",
			height: pxToRem(8),
			width: pxToRem(4),
			backgroundRepeat: "no-repeat",
			backgroundSize: "100% 100%",
			backgroundImage: `url(${require("@/assets/images/icons/arrow_right.png")})`,
			zIndex: 1,
		},
	},
	adminBox: {
		display: "flex",
		justifyContent: "space-between",
		padding: `${pxToRem(6)} ${pxToRem(7)}`,
	},
	adminButton: {
		height: pxToRem(25),
		width: pxToRem(103),
		borderRadius: pxToRem(12.5),
		"--text-color": "#82E8FF",
		backgroundColor: "transparent",
		borderColor: "#2F3A62",
		fontSize: pxToRem(13),
		fontWeight: 500,
		padding: 0,
	},
});
